<div class="skylark-app-preview">
  <div class="background">
    <div class="background-inner">

      <ng-container *ngFor="let field of formFields; let i = index;">

        <!-- inputs -->
        <!-- text field -->
        <ng-container *ngIf="field.type === 'textField'">

          <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span></label>
          <input type="text" readonly/>
        </ng-container>

        <!-- text area -->
        <ng-container *ngIf="field.type === 'textArea'">

          <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span></label>
          <textarea readonly></textarea>

        </ng-container>

        <!-- date field -->
        <ng-container *ngIf="field.type === 'dateField'">

          <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span></label>
          <input type="date" readonly/>
        </ng-container>

        <!-- time field -->
        <ng-container *ngIf="field.type === 'timeField'">

          <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span></label>
          <input type="time" readonly/>
        </ng-container>

        <!-- radio button list -->
        <ng-container *ngIf="field.type === 'radioButton'">
          <div class="list-group">
            <span class="list-group-header">{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span> </span>

            <ng-container *ngFor="let option of field.options; let ro = index">
              <div class="radio-button-line">
                <label>{{option}}</label>
                <input type="radio" [name]="'radio_' + i" [checked]="ro === 0 ? true : false" [value]="option">
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- checkbox list -->
        <ng-container *ngIf="field.type === 'checkboxList'">
          <div class="list-group">
            <span class="list-group-header">{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span> </span>

            <ng-container *ngFor="let option of field.options; let co = index">
              <div class="checkbox-button-line">
                <input type="checkbox" [name]="'checkbox_' + i" [checked]="co < 2 ? true : false" [value]="option">
                <label>{{option}}</label>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- image upload -->
        <ng-container *ngIf="field.type === 'imageUpload'">
          <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span></label>
          <label>0 photos selected</label>
          <div><button class="preview-button-primary">Upload</button></div>
        </ng-container>

        <!-- document upload -->
        <ng-container *ngIf="field.type === 'documentUpload'">
          <label>{{field.label ? field.label : 'Question' }} <span *ngIf="field.required" class="required-star">*</span></label>
          <label>0 documents selected</label>
          <div><button class="preview-button-primary">Upload</button></div>
        </ng-container>

        <!-- table -->
        <ng-container *ngIf="field.type === 'table'">
          <label>{{field.label ? field.label : 'Table Header'}} <span *ngIf="field.required" class="required-star">*</span></label>

          <div class="table-wrapper">
            <table>
              <thead >
                <tr >
                  <th *ngFor="let fieldInner of field.fields">{{fieldInner.label ? fieldInner.label : 'Question'}}</th>
                  <th style=" color: blue"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style=" color: white" *ngFor="let fieldInner of field.fields">xxxxxxx</td><td style=" color: blue">edit</td>
                </tr>
                <tr>
                  <td style=" color: white" *ngFor="let fieldInner of field.fields">xxxxxxx</td><td style=" color: blue">edit</td>
                </tr>
                <tr>
                  <td style=" color: white" *ngFor="let fieldInner of field.fields">xxxxxxx</td><td style=" color: blue">edit</td>
                </tr>
              </tbody>
            </table>
            <button>(new rows will appear, as many as needed)</button>
          </div>
        </ng-container>

        <!-- structure -->
        <ng-container *ngIf="field.type === 'headerLarge'">
          <h2>{{field.text ? field.text : 'Header' }}</h2>
        </ng-container>
        <ng-container *ngIf="field.type === 'headerSmall'">
          <h4>{{field.text ? field.text : 'Header' }}</h4>
        </ng-container>

        <ng-container *ngIf="field.type === 'paragraphOfText'">
          <p class="textarea">{{field.textarea ? field.textarea : 'Information text to explain or provide more details' }}</p>
        </ng-container>

      </ng-container>
    </div>
  </div>
</div>
